import { motion } from "framer-motion";

/**
 * Scroll-reveal wrapper. Fades + slides children into view once.
 * Respects prefers-reduced-motion via framer-motion defaults.
 */
export const Reveal = ({
  children,
  delay = 0,
  y = 24,
  className = "",
  once = true,
  as = "div",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

/**
 * Staggered container — children using <RevealItem> animate in sequence.
 */
export const RevealGroup = ({ children, className = "", stagger = 0.1, ...rest }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger } },
    }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className = "", y = 24, ...rest }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
    }}
    {...rest}
  >
    {children}
  </motion.div>
);
